import {
  VisitCreationRequestDto,
  VisitDto,
  VisitUpdateRequestDto,
  VisitWithFeedItemDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const visitsRequests = {
  createVisit: EndpointDefinition.post<
    VisitWithFeedItemDto,
    VisitCreationRequestDto,
    null
  >({
    name: 'createVisit',
    route: '/visits',
  }),

  updateVisit: EndpointDefinition.patch<
    VisitDto,
    VisitUpdateRequestDto,
    { visitId: number }
  >({
    name: 'updateVisit',
    route: '/visits/:visitId',
  }),

  deleteVisit: EndpointDefinition.delete<null, { visitId: number }>({
    name: 'deleteVisit',
    route: '/visits/:visitId',
  }),
};
